<template>
  <Teleport :to="leftArrow">
    <span>
      &#9664;
    </span>
  </Teleport>
  <Teleport :to="rightArrow">
    <span>
      &#9654;
    </span>
  </Teleport>
</template>

<script>
import CoreComponent from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue";
import { carouselClicksTracking } from "../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/ACDLHandler";

export default {
  extends: CoreComponent,

  computed: {
    leftArrow() {
      return this.cmpEl.querySelector(".cmp-carousel__action--previous");
    },

    rightArrow() {
      return this.cmpEl.querySelector(".cmp-carousel__action--next");
    },
  },

  mounted() {
    const carouselwrapper = this.cmpEl.querySelector(".cmp-carousel__content");

    const leftnav = this.cmpEl
      .querySelector(".cmp-carousel__action--previous")
      .querySelector(".cmp-carousel__action-text");
    leftnav.remove();

    const rightnav = this.cmpEl
      .querySelector(".cmp-carousel__action--next")
      .querySelector(".cmp-carousel__action-text");
    rightnav.remove();

    const carouselItems = this.cmpEl.querySelectorAll(".cmp-carousel__item");

    let isBanner = this.cmpEl.classList.contains("cmp-carousel--banner");

    const lightBg = this.cmpEl.dataset.backgroundImage;
    const darkBg = this.cmpEl.dataset.backgroundImageDark;

    const applyBackground = () => {
      const isDark = document.body.classList.contains('tw-dark');
      const bgImage = isDark && darkBg ? darkBg : lightBg;
      let target = this.cmpEl;
      if (!isBanner) {
        target = target.parentElement;
      }
      target.style.backgroundImage = bgImage ? `url(${bgImage})` : '';
    };

    let maxHeightItem = [];

    carouselItems.forEach((item) => {
      maxHeightItem.push(item.offsetHeight);
    });
    carouselwrapper.style.height = Math.max(...maxHeightItem) + "px";

    if (isBanner) {
      let columnBands = this.cmpEl.querySelectorAll(".cmp-columnBand__container");
      let bandHeight = carouselwrapper.style.height;
      columnBands.forEach(band => {
        band.style.height = bandHeight;
      });
    }

    applyBackground();

    this._darkModeObserver = new MutationObserver(() => {
      applyBackground();
    });

    this._darkModeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    this.leftArrow.addEventListener("click", () => {
      //Add Carousel Analytics
      indicators.forEach((indicator, index) => {
        if (indicator.classList.contains('cmp-carousel__indicator--active')) {
          if(index <= 0) {
            carouselClicksTracking(this.cmpId, "Corporate Carousel", indicators.length - 1);
          }
          else {
            carouselClicksTracking(this.cmpId, "Corporate Carousel", index - 1);
          }
        }
      });

      carouselItems.forEach((item) => {
        item.style.animation = "";
        item.style.visibility = "hidden";
      });

      setTimeout(() => {
        this.cmpEl.querySelector(
          ".cmp-carousel__item--active"
        ).style.visibility = "visible";
        this.cmpEl.querySelector(
          ".cmp-carousel__item--active"
        ).style.animation = "moveRightActive 0.7s";
      }, 300);
    });

    this.rightArrow.addEventListener("click", () => {
      //Add Carousel Analytics
      indicators.forEach((indicator, index) => {
        if (indicator.classList.contains('cmp-carousel__indicator--active')) {
          if(index >= indicators.length - 1) {
            carouselClicksTracking(this.cmpId, "Corporate Carousel", 0);
          }
          else {
            carouselClicksTracking(this.cmpId, "Corporate Carousel", index + 1);
          }
        }
      });
     
      carouselItems.forEach((item) => {
        item.style.animation = "";
        item.style.visibility = "hidden";
      });

      setTimeout(() => {
        this.cmpEl.querySelector(
          ".cmp-carousel__item--active"
        ).style.visibility = "visible";
        this.cmpEl.querySelector(
          ".cmp-carousel__item--active"
        ).style.animation = "moveLeftActive 0.7s";
      }, 300);
    });

    // Move arrows to avoid covering content, remove original parent
    const controlWrapper = this.cmpEl.querySelector(".cmp-carousel__controls");
    controlWrapper.prepend(this.leftArrow);
    controlWrapper.append(this.rightArrow);
    this.cmpEl.querySelector(".cmp-carousel__actions").remove();

    const indicators = this.cmpEl.querySelectorAll('.cmp-carousel__indicators .cmp-carousel__indicator')
    indicators.forEach((indicator, index) => {
      indicator.addEventListener("click", () => {
        //Add Carousel Analytics
        carouselClicksTracking(this.cmpId, "Corporate Carousel", index);

        carouselItems.forEach((item) => {
          item.style.removeProperty("visibility");
        });
      })
    })
  },

  beforeUnmount() {
    if (this._darkModeObserver) {
      this._darkModeObserver.disconnect();
    }
  },
};
</script>

<style lang="scss">
@import "./corporateCarousel.scss";
</style>